import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { 
  Calendar, Clock, Users, Bell, 
  Share2, MapPin, ArrowRight 
} from 'lucide-react';

const DigiCalendarLanding = () => {
  const navigate = useNavigate();

  const features = [
    {
      icon: <Calendar className="w-8 h-8" />,
      title: "Smart Scheduling",
      description: "Set your availability and let clients book meetings automatically. No login required for them!"
    },
    {
      icon: <Clock className="w-8 h-8" />,
      title: "Flexible Durations",
      description: "Support for 15, 30, 45, and 60-minute meeting slots. Create custom event types"
    },
    {
      icon: <Users className="w-8 h-8" />,
      title: "Meeting Management",
      description: "View, reschedule, and cancel meetings in one dashboard. Track upcoming and past meetings"
    },
    {
      icon: <Bell className="w-8 h-8" />,
      title: "Google Calendar Sync",
      description: "Sync with Google Calendar to show real-time availability. Prevent double bookings"
    },
    {
      icon: <Share2 className="w-8 h-8" />,
      title: "Public Booking Page",
      description: "Share your booking link anywhere. Clients can book without creating an account"
    },
    {
      icon: <MapPin className="w-8 h-8" />,
      title: "Timezone Support",
      description: "Automatic timezone detection and conversion for global meetings. Works worldwide"
    }
  ];

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 via-white to-slate-50">
      <div className="container mx-auto px-4 py-16">
        <div className="text-center mb-16">
          <h1 className="text-5xl md:text-6xl font-bold text-gray-900 mb-6">
            Digi<span className="text-blue-600">Calendar</span>
          </h1>
          <p className="text-xl md:text-2xl text-gray-600 mb-8 max-w-3xl mx-auto">
            Simplified Meeting Scheduling - Let Clients Book Time with You
          </p>
          <div className="flex gap-4 justify-center flex-wrap">
            <Button
              onClick={() => navigate('/auth')}
              className="bg-blue-600 hover:bg-blue-700 text-white px-8 py-6 text-lg rounded-full"
            >
              Start Scheduling <ArrowRight className="ml-2 w-5 h-5" />
            </Button>
            <Button
              onClick={() => navigate('/digi-schedule')}
              variant="outline"
              className="px-8 py-6 text-lg rounded-full border-2 border-blue-600 text-blue-600 hover:bg-blue-50"
            >
              View Demo
            </Button>
          </div>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8 mb-16">
          {features.map((feature, index) => (
            <div
              key={index}
              className="bg-white p-8 rounded-2xl shadow-lg hover:shadow-xl transition-all border border-gray-100"
            >
              <div className="text-blue-600 mb-4">{feature.icon}</div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">{feature.title}</h3>
              <p className="text-gray-600">{feature.description}</p>
            </div>
          ))}
        </div>

        <div className="bg-gradient-to-r from-blue-600 to-blue-700 rounded-3xl p-12 text-center text-white">
          <h2 className="text-3xl md:text-4xl font-bold mb-4">
            Simplify Your Scheduling Today
          </h2>
          <p className="text-xl mb-8 opacity-90">
            Join professionals managing their calendar smarter
          </p>
          <Button
            onClick={() => navigate('/auth')}
            className="bg-white text-blue-600 hover:bg-gray-100 px-8 py-6 text-lg rounded-full font-semibold"
          >
            Get Started Free
          </Button>
        </div>
      </div>
    </div>
  );
};

export default DigiCalendarLanding;